import React from "react";
const SvgMapAddress = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#1A1F24"
      fillRule="evenodd"
      d="M14 5.5a.5.5 0 01.5-.5h2a.5.5 0 01.488.392l1.03 4.633a4.5 4.5 0 11-.976.216l-.287-1.289-5.901 5.902A.5.5 0 0110.5 15h-.527A4.5 4.5 0 015.5 19 4.499 4.499 0 011 14.5a4.499 4.499 0 016.468-4.045l.756-.84L7.648 8H7a.5.5 0 010-1h3a.5.5 0 010 1H8.71l.35.98 7.393-1.386L16.1 6h-1.6a.5.5 0 01-.5-.5zm-5.394 5.185L5.623 14H9.79l-1.185-3.315zm2.1 2.903L9.4 9.934l6.104-1.145-4.799 4.799zM5.5 18a3.5 3.5 0 003.465-3H4.5a.5.5 0 01-.372-.835l2.636-2.927A3.499 3.499 0 002 14.5C2 16.434 3.566 18 5.5 18zm12.512-3.392l-.752-3.382A3.501 3.501 0 0018.5 18a3.5 3.5 0 10-.263-6.99l.751 3.382a.5.5 0 01-.976.216z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMapAddress;
